import * as React from "react";
import {
    Intersection,
    IIntersectionContext,
    IntersectionContext,
} from "azure-devops-ui/Intersection";
import { announce } from "azure-devops-ui/Core/Util/Accessibility";

interface IIntersectionExampleState {
    visibility: number;
}

export default class IntersectionExample extends React.Component<{}, IIntersectionExampleState> {
    private intersectionContext: IIntersectionContext;
    private observing = false;

    public constructor(props: {}) {
        super(props);
        this.state = { visibility: 0 };
    }

    public componentDidMount() {
        if (this.intersectionContext) {
            this.intersectionContext.register(this.onIntersect);
        }
    }

    public componentWillUnmount() {
        if (this.intersectionContext) {
            this.intersectionContext.unregister(this.onIntersect);
        }
    }

    public render(): JSX.Element {
        return (
            <div className="flex-column" style={{ height: "400px" }}>
                <div
                    className="flex-row justify-center"
                    style={{
                        width: "700px",
                        marginBottom: "16px",
                    }}
                >
                    {"Percentage Visible " + this.state.visibility}
                </div>
                <Intersection>
                    <div className="flex-grow scroll-auto">
                        <IntersectionContext.Consumer>
                            {(intersectionContext) => {
                                this.intersectionContext = intersectionContext;
                                return (
                                    <div
                                        className="flex-row"
                                        style={{
                                            height: "1200px",
                                            width: "700px",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <img
                                            alt="bars"
                                            ref={(tableBodyElement) =>
                                                this.observeTableBody(tableBodyElement)
                                            }
                                            src={require("./bars.png")}
                                            style={{ height: "200px" }}
                                            tabIndex={0}
                                        />
                                    </div>
                                );
                            }}
                        </IntersectionContext.Consumer>
                    </div>
                </Intersection>
            </div>
        );
    }

    private observeTableBody = (tableBodyElement: HTMLElement | null) => {
        if (tableBodyElement && this.intersectionContext && !this.observing) {
            this.intersectionContext.observe(tableBodyElement);
            this.observing = true;
        }
    };

    private onIntersect = (entries: IntersectionObserverEntry[]) => {
        if (entries.length) {
            const visibility = Math.round(entries[0].intersectionRatio * 100);
            if (visibility !== this.state.visibility) {
                this.setState({ visibility });
                announce("Percentage Visible " + visibility);
            }
        }
    };
}
